<template>
    <AutocompleteField
        v-model="$hotel"
        :label="label"
        right-icon="fa-solid fa-briefcase"
        endpoint="/clients/autocomplete"
        :errors="errors"
        :filters="filters"
        add-route="ClientCreate"
        edit-route="ClientUpdate"
        route-param-name="client"
        i18n
    >
    </AutocompleteField>
</template>

<script>
import AutocompleteField from "./AutocompleteField.vue";

export default {
    name: "T3ClientAutocompleteField",
    components: {
        AutocompleteField,
    },
    props: {
        modelValue: {
            type: Object,
            default: null,
        },
        label: {
            type: String,
            default: "Client",
        },
        errors: {
            type: Array,
            default: () => [],
        },
        active: {
            type: Boolean,
            default: undefined,
        },
        appId: {
            type: Number,
            default: undefined,
        },
        countryId: {
            type: String,
            default: "",
        },
        divisionId: {
            type: Number,
            default: 0,
        },
        locationId: {
            type: Number,
            default: 0,
        },
    },
    emits: ["update:model-value"],
    computed: {
        $hotel: {
            get() {
                return this.modelValue;
            },
            set(newval) {
                this.$emit("update:model-value", newval);
            },
        },
        filters() {
            const result = {};

            if (this.active !== undefined) {
                result.active = this.active ? 1 : 0;
            }

            if (this.appId) {
                result.app_id = this.appId;
            }

            if (this.countryId) {
                result.country_id = this.countryId;
            }

            if (this.divisionId) {
                result.division_id = this.divisionId;
            }

            if (this.locationId) {
                result.location_id = this.locationId;
            }

            return result;
        },
    },
};
</script>
